import { AssignedClinicianSection } from './assigned-clinician-section'
import { ReassignmentCardBase } from './base'
import { SelfScheduleSection } from './self-schedule-section'

interface ReassignmentInProgressCardProps {
  status: 'approved' | 'assigned_to_cc'
  effectiveDate: string
  requesterType: string
  canTakeAction: boolean
  canCancel?: boolean
  onReassignClick?: () => void
  onCancelClick?: () => void
  onViewDetailsClick?: () => void
  clinicianName?: string
  clinicianEmail?: string
  onClinicianNameClick?: () => void
  clinicianEmailCopied?: boolean
  showSelfScheduleSection?: boolean
  selfScheduleUrl?: string
  onSelfScheduleLinkCopy?: (url: string) => void
  selfScheduleDisabledReasons?: string[]
}

export function ReassignmentInProgressCard({
  status,
  effectiveDate,
  requesterType,
  canTakeAction,
  canCancel = false,
  onReassignClick,
  onCancelClick,
  onViewDetailsClick,
  clinicianName,
  clinicianEmail,
  onClinicianNameClick,
  clinicianEmailCopied = false,
  showSelfScheduleSection = false,
  selfScheduleUrl,
  onSelfScheduleLinkCopy,
  selfScheduleDisabledReasons = [],
}: ReassignmentInProgressCardProps) {
  const subtitle = `Effective ${effectiveDate} | ${requesterType}`

  // Derive badge from status
  const badgeText = status === 'assigned_to_cc' ? 'Assigned to CC' : 'Approved'
  const badgeColor = status === 'assigned_to_cc' ? 'gold' : 'mint'
  const badge = { label: badgeText, color: badgeColor as 'mint' | 'gold' }

  // Action button
  const actionButton =
    canTakeAction && onReassignClick
      ? { label: 'Reassign now', onClick: onReassignClick }
      : undefined

  const cancelButton =
    canCancel && onCancelClick ? { label: 'Cancel', onClick: onCancelClick } : undefined

  // Show assigned clinician section if we have clinician name
  const showAssignedClinician = !!clinicianName

  return (
    <ReassignmentCardBase
      title="Reassignment In Progress"
      subtitle={subtitle}
      badge={badge}
      actionButton={actionButton}
      secondaryActionButton={cancelButton}
      onViewDetailsClick={onViewDetailsClick}
    >
      {/* Assigned Clinician section */}
      {showAssignedClinician && (
        <AssignedClinicianSection
          clinicianName={clinicianName}
          clinicianEmail={clinicianEmail}
          onClinicianNameClick={onClinicianNameClick}
          emailCopied={clinicianEmailCopied}
        />
      )}

      {/* Self-schedule section */}
      {showSelfScheduleSection && (
        <SelfScheduleSection
          selfScheduleUrl={selfScheduleUrl}
          onSelfScheduleLinkCopy={onSelfScheduleLinkCopy}
          selfScheduleDisabledReasons={selfScheduleDisabledReasons}
        />
      )}
    </ReassignmentCardBase>
  )
}
